import { render, staticRenderFns } from "./Disk.vue?vue&type=template&id=9452079a&scoped=true"
import script from "./Disk.vue?vue&type=script&lang=js"
export * from "./Disk.vue?vue&type=script&lang=js"
import style0 from "./Disk.vue?vue&type=style&index=0&id=9452079a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9452079a",
  null
  
)

export default component.exports